import React from 'react';
import ReactDOM from 'react-dom/client';
import Path from './path';

import { MusicProvider } from './components/common/music';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <MusicProvider>
      <Path />
    </MusicProvider>
  </React.StrictMode>
);